import React, { useState } from "react";
import CloseForm from "../Master/CloseForm";
import "../../css_files/Technician/GenerateReport.css";
import moment from "moment/moment";
import axiosInstance from "../../api";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";

function GenerateReport({
  username,
  close,
  payload,
  setPayload,
  setPerformanceData,
  setShowPerformancePopup,
}) {
  const months = [
    "December",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
  ];

  const [loading, setloading] = useState(false);

  function generateHTML(data) {
    return `
    <div style="padding:20px;font-family:sans-serif;">
  
      <div style="text-align:center;">
        <h2>ROSS BOILERS</h2>
        <p>No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048</p>
        <h3>Technician ${payload.Duration} Report from ${moment(
      new Date(payload.FromDate)
    ).format("DD/MM/YYYY")} to ${moment(new Date(payload.ToDate)).format(
      "DD/MM/YYYY"
    )}</h3>
      </div>
  
      <br/>
  
      <h3>PARTICULARS</h3>
  
      <table border="1"
        cellspacing="0"
        cellpadding="6"
        width="100%"
        style="border-collapse:collapse;text-align:center;">
  
        <thead>
          <tr>
            <th>Voucher Id</th>
            <th>Ticket Id</th>
            <th>Customer Name</th>
            <th>Invoice Amount</th>
            <th>Voucher Amount</th>
            <th>Technician Name</th>
            <th>Vocher Date</th>
          </tr>
        </thead>
  
        <tbody>
          ${data
            ?.map(
              (v) => `
            <tr>
              <td>
                ${v?.voucherNumber}
              </td>
  
              <td>
                ${v?.ticket?.seriesId}
              </td>
  
              <td>
                ${v?.ticket?.customer?.orgName}
              </td>
  
              <td>
                ${v?.ticket.billAmount}
              </td>
              <td>
                ${v?.vouchers.reduce((sum, v) => sum + (v.amount ?? 0.0), 0.0)}
              </td>
              <td>
                ${v?.userId}
              </td>
              <td>
                ${moment(new Date(v?.updateDate ?? v?.createdDate)).format(
                  "DD/MM/YYYY"
                )}
              </td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
  
      <br/>
  
      <br/><br/><br/>
  
      <table width="100%">
        <tr>
          <td>Receiver’s Sign</td>
          <td style="text-align:center;">Verified By</td>
          <td style="text-align:right;">Authorized By</td>
        </tr>
      </table>
  
    </div>
    `;
  }

  function generatePerformanceReportMonth(data) {
    return `
    <div style="padding:20px;font-family:sans-serif;">
  
      <div style="text-align:center;">
        <h2>ROSS BOILERS</h2>
        <p>No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048</p>
        <h3>Technician Performance Report from ${moment(
          new Date(payload.FromDate)
        ).format("DD/MM/YYYY")} to ${moment(new Date(payload.ToDate)).format(
      "DD/MM/YYYY"
    )}</h3>
      </div>
  
  
      <table border="1"
        cellspacing="0"
        cellpadding="6"
        width="100%"
        style="border-collapse:collapse;text-align:center;">
  
        <thead>
          <tr>
            <th>Date</th>
            <th>Ticket Id</th>
            <th>Invoice Value</th>
            <th>Factory Work Value</th>
            <th>Voucher Amount</th>
            <th>Travel Days</th>
            <th>Company/Organization Name</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Balance</th>
            <th>Voucher Id</th>
          </tr>
        </thead>
  
        <tbody>
          ${data
            ?.map((x) =>
              x?.data.map(
                (v) => `
            <tr>
              <td>
                ${moment(new Date(x?.date)).format("DD-MM-YYYY")}
              </td>
  
              <td>
                ${v?.ticketId}
              </td>
  
              <td>
                ${parseFloat(v?.invoice).toFixed(2)}
              </td>
  
              <td>
                ${parseFloat(v?.factoryWorkValue ?? "0").toFixed(2)}
              </td>
              <td>
                ${v?.voucherAmount}
              </td>
              <td>
                ${v?.travelDays}
              </td>
              <td>
                ${v?.company}
              </td>
              <td>
                ${moment(new Date(v?.startDate)).format("DD-MM-YYYY")}
              </td>
              <td>
                ${moment(new Date(v?.endDate)).format("DD-MM-YYYY")}
              </td>
              <td>
                ${v?.balance}
              </td>
              <td>
                ${v?.voucherId}
              </td>
            </tr>
          `
              )
            )
            .join("")}
        </tbody>
      </table>
  
      
  
    </div>
    `;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (payload.Type == "Performance") {
      if (payload.Duration == "Yearly") {
        setloading(true);
        axiosInstance
          .post(
            `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTechnicianPerformanceReport`,
            {
              FromDate: payload.FromDate,
              Username: username,
              ToDate: payload.ToDate,
            }
          )
          .then((res) => {
            const data = res.data;
            const years = data?.map((x) => x.year);
            const setYears = Array.from(new Set(years)).map((x) =>
              x.toString().substring(2)
            );
            setPerformanceData([
              ...data,
              {
                year: "Total " + setYears.join("-"),
                salary: data?.reduce((acc, curr) => acc + curr.salary, 0.0),
                voucherAmount: data?.reduce(
                  (acc, curr) => acc + curr.voucherAmount,
                  0.0
                ),
                invoiceAmount: data?.reduce(
                  (acc, curr) => acc + curr.invoiceAmount,
                  0.0
                ),
                factoryWorkValue: data?.reduce(
                  (acc, curr) => acc + curr.factoryWorkValue,
                  0.0
                ),
                totalCost: data?.reduce(
                  (acc, curr) => acc + curr.totalCost,
                  0.0
                ),
                paymentBalance: data?.reduce(
                  (acc, curr) => acc + curr.paymentBalance,
                  0.0
                ),
                profitLoss: data?.reduce(
                  (acc, curr) => acc + curr.profitLoss,
                  0.0
                ),
                numberOfDays: "",
              },
            ]);
            setShowPerformancePopup(true);
            setloading(false);
            close(false);
          })
          .catch((err) => {
            setShowPerformancePopup(false);
            setloading(false);
            close(false);
            toast.error(err?.response?.data?.error, {
              position: "bottom-center",
              theme: "dark",
            });
          });
      } else {
        setloading(true);
        axiosInstance
          .post(
            `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTechnicianMonthlyReport`,
            {
              FromDate: payload.FromDate,
              Username: username,
              ToDate: payload.ToDate,
            }
          )
          .then((res) => {
            setShowPerformancePopup(false);
            setloading(false);
            const html = generatePerformanceReportMonth(res.data);
            const element = document.createElement("div");
            element.innerHTML = html;

            const options = {
              margin: 0.5,
              filename: `report${Date.now()}.pdf`,
              image: { type: "jpeg", quality: 1 },
              html2canvas: { scale: 2 },
              jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "landscape",
              },
            };

            html2pdf()
              .set(options)
              .from(element)
              .save()
              .then(() => {
                close(false);
              });
          })
          .catch((err) => {
            close(false);
            setloading(false);
            toast.error(err?.response?.data?.error, {
              position: "bottom-center",
              theme: "dark",
            });
          });
      }
    } else {
      setloading(true);
      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTechnicianWeeklyReports`,
          {
            FromDate: payload.FromDate,
            Username: username,
            ToDate: payload.ToDate,
          }
        )
        .then((res) => {
          setloading(false);
          setShowPerformancePopup(false);
          const html = generateHTML(res.data);
          const element = document.createElement("div");
          element.innerHTML = html;

          const options = {
            margin: 0.5,
            filename: `report${Date.now()}.pdf`,
            image: { type: "jpeg", quality: 1 },
            html2canvas: { scale: 2 },
            jsPDF: {
              unit: "in",
              format: "a4",
              orientation: "portrait",
            },
          };

          html2pdf()
            .set(options)
            .from(element)
            .save()
            .then(() => {
              close(false);
            });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.error, {
            position: "bottom-center",
          });
          setloading(false);
          close(false);
        });
    }
  }

  return (
    <div className="generate-report-technician">
      <form onSubmit={handleSubmit}>
        <h2>Generate {payload.Duration} Report</h2>
        <blockquote className="generate-report-technician-duration">
          <label>Select Duration</label>
          <blockquote>
            Weekly{" "}
            <input
              checked={payload.Duration === "Weekly"}
              type="radio"
              onChange={(e) => {
                setPayload({
                  Duration: "Weekly",
                  FromDate: moment(
                    new Date(Date.now() - 7 * 86400 * 1000)
                  ).format("YYYY-MM-DD"),
                  ToDate: moment(new Date()).format("YYYY-MM-DD"),
                  Type: "Voucher",
                });
              }}
            />
            Monthly{" "}
            <input
              checked={payload.Duration === "Monthly"}
              type="radio"
              onChange={(e) => {
                setPayload({
                  Type: "Performance",
                  Duration: "Monthly",
                  FromDate: moment(
                    new Date(Date.now() - 30 * 86400 * 1000)
                  ).format("YYYY-MM-DD"),
                  ToDate: moment(new Date()).format("YYYY-MM-DD"),
                });
              }}
            />
            Yearly{" "}
            <input
              checked={payload.Duration === "Yearly"}
              type="radio"
              onChange={(e) => {
                setPayload({
                  Type: "Performance",
                  Duration: "Yearly",
                  FromDate: moment(
                    new Date(Date.now() - 365 * 86400 * 1000)
                  ).format("YYYY-MM-DD"),
                  ToDate: moment(new Date()).format("YYYY-MM-DD"),
                });
              }}
            />
          </blockquote>
        </blockquote>
        {/*["Yearly", "Monthly"].includes(payload.Duration) && (
          <blockquote className="generate-report-technician-duration">
            <label>Select Type</label>
            <blockquote>
              Voucher{" "}
              <input
                checked={payload.Type === "Voucher"}
                type="radio"
                onChange={(e) => {
                  setPayload({
                    Type: "Voucher",
                    Duration: payload.Duration,
                    FromDate: moment(
                      new Date(
                        Date.now() -
                          (payload.Duration == "Monthly"
                            ? 30 * 86400 * 1000
                            : 365 * 86400 * 1000)
                      )
                    ).format("YYYY-MM-DD"),
                    ToDate: moment(new Date()).format("YYYY-MM-DD"),
                  });
                }}
              />
              Performance{" "}
              <input
                checked={payload.Type === "Performance"}
                type="radio"
                onChange={(e) => {
                  setPayload({
                    Type: "Performance",
                    Duration: payload.Duration,
                    FromDate: moment(
                      new Date(
                        Date.now() -
                          (payload.Duration == "Monthly"
                            ? 30 * 86400 * 1000
                            : 365 * 86400 * 1000)
                      )
                    ).format("YYYY-MM-DD"),
                    ToDate: moment(new Date()).format("YYYY-MM-DD"),
                  });
                }}
              />
            </blockquote>
          </blockquote>
        )*/}
        <blockquote>
          <label>From</label>
          <input
            required
            type="date"
            placeholder="Select From Date"
            value={payload.FromDate}
            onChange={(e) => {
              const fromDate = new Date(e.target.value);
              setPayload({
                ...payload,
                FromDate: e.target.value,
                ToDate: moment(
                  new Date(
                    fromDate.getTime() +
                      (payload.Duration == "Weekly"
                        ? 7 * 86400 * 1000
                        : payload.Duration == "Monthly"
                        ? 30 * 86400 * 1000
                        : payload.Duration == "Yearly"
                        ? 365 * 86400 * 1000
                        : 0)
                  )
                ).format("YYYY-MM-DD"),
              });
            }}
          />
        </blockquote>
        <blockquote>
          <label>To</label>
          <input
            type="date"
            placeholder="Select To Date"
            readOnly
            value={payload.ToDate}
          />
        </blockquote>
        <button type={loading ? "button" : "submit"}>
          {loading ? (
            <i className="fa-solid fa-spinner fa-spin fa-2x"></i>
          ) : (
            "Submit"
          )}
        </button>
      </form>
      <CloseForm close={close} />
    </div>
  );
}

export default GenerateReport;
